import type {
  AuditLogInsertInput,
  DeleteCustomerSecretInput,
  InvalidateCustomerSecretCacheInput,
  UpsertCustomerSecretInput,
} from '@/generated/graphql';
import { TypedDocumentString } from '@/generated/graphql';

// Hand-typed: codegen only reads .tsx documents.

export const upsertCustomerSecretSenhubMutation = new TypedDocumentString<
  {
    upsertCustomerSecret: { uri: string };
    invalidateCustomerSecretCache: { success: boolean };
  },
  {
    input: UpsertCustomerSecretInput;
    invalidateCacheInput: InvalidateCustomerSecretCacheInput;
  }
>(`
  mutation upsertCustomerSecret(
    $input: UpsertCustomerSecretInput!
    $invalidateCacheInput: InvalidateCustomerSecretCacheInput!
  ) {
    upsertCustomerSecret(input: $input) {
      uri
    }
    invalidateCustomerSecretCache(input: $invalidateCacheInput) {
      success
    }
  }
`);

export const deleteCustomerSecretSenhubMutation = new TypedDocumentString<
  { deleteCustomerSecret: { name: string; deleted: boolean } },
  { input: DeleteCustomerSecretInput }
>(`
  mutation deleteCustomerSecret($input: DeleteCustomerSecretInput!) {
    deleteCustomerSecret(input: $input) {
      name
      deleted
    }
  }
`);

export const insertCustomerSecretAuditLogMutation = new TypedDocumentString<
  { insertAuditLogOne?: { id: string } | null },
  { auditLogInput: AuditLogInsertInput }
>(`
  mutation insertCustomerSecretAuditLog($auditLogInput: AuditLogInsertInput!) {
    insertAuditLogOne(object: $auditLogInput) {
      id
    }
  }
`);
